// control the input to only accept integer numbers
export const handleNumberKeyDown = (
  event: React.KeyboardEvent<HTMLInputElement>,
): void => {
  if (
    !/[0-9]/.test(event.key) &&
    event.key !== 'Backspace' &&
    event.key !== 'Delete'
  ) {
    event.preventDefault();
  }
};
